"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _events = _interopRequireWildcard(require("./events"));
var _handleError = _interopRequireDefault(require("../sentry/handleError"));
var _errors = _interopRequireDefault(require("../sentry/errors.json"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
var validator = function validator(eventId, eventProperties) {
  var configEvent = _events["default"][eventId];

  // Check if the eventId passed in is one of the accepted events
  if (!configEvent) {
    (0, _handleError["default"])(_errors["default"].segmentEventIdMissing, eventId);
    return false;
  }

  // Validate the event properties
  var properties = configEvent.properties;
  var configProperties = _objectSpread(_objectSpread({}, properties), _events.universalProperties);

  // make sure no unexpected properties passed in
  for (var property in eventProperties) {
    if (configProperties[property] === undefined) {
      (0, _handleError["default"])(_errors["default"].segmentUnexpectEventProperty, property);
      return false;
    }
  }
  return Object.keys(configProperties).reduce(function (acc, property) {
    // if an error has been detected, skip validating other properties
    if (!acc) {
      return false;
    }
    var eventPropValue = eventProperties[property];
    var _configProperties$pro = configProperties[property],
      isRequired = _configProperties$pro.isRequired,
      type = _configProperties$pro.type,
      acceptedValues = _configProperties$pro.acceptedValues;

    // If the value exists for the property being checked
    if (eventPropValue !== undefined) {
      // Check if the value of the property is the right type 
      if (type !== _typeof(eventPropValue)) {
        (0, _handleError["default"])(_errors["default"].segmentIncorrectPropertyType, "".concat(property, ", type ").concat(_typeof(eventPropValue)));
        return false;
      }

      // Check if the value is one of the accepted values for that (if needed)
      if (acceptedValues && !acceptedValues.has(eventPropValue)) {
        (0, _handleError["default"])(_errors["default"].segmentIncorrectPropertyValue, eventPropValue);
        return false;
      }
      // Check if the event property was required 
    } else if (isRequired) {
      (0, _handleError["default"])(_errors["default"].segmentPropertyMissing, property);
      return false;
    }
    return true;
  }, true);
};
var _default = validator;
exports["default"] = _default;